import { Activity } from "./Activity.model";
import { Pupil } from "./Pupil.model";
import { LessonItem } from "@/models/LessonItem.model";
import { Observation } from "@/models/Observation.model";
import { Duration } from "luxon";
import { usePupilsStore } from "@/stores/Pupils.store";
import { useActivitiesStore } from "@/stores/Activities.store.ts";

export class PupilActivity {

	static mapFromServer(data: any, pupil: Pupil | null = null): PupilActivity {
		return (new PupilActivity()).setFromServerData(data, pupil);
	}

	public id ?: String;
	public checkin ?: Date;
	public checkout ?: Date;
	public activity ?: Activity;
	public pupil ?: Pupil;
	public lessonItem ?: LessonItem;
	public observations ?: Observation[];
	public feedback ?: number;
	public duration ?: Duration;
	public breakDuration ?: Duration;

	setFromServerData(data: any, pupil: Pupil | null = null) {

		this.id = data.id;
		this.checkin = data.checkin ? new Date(data.checkin) : undefined;
		this.checkout = data.checkout ? new Date(data.checkout) : undefined;

		if (data.activity) {
			const activity = useActivitiesStore().findById(data.activity.id);
			if (activity) {
				this.activity = activity;
			} else {
				this.activity = Activity.mapFromServer(data.activity);
			}
		}

		if (data.lessonItem) {
			this.lessonItem = LessonItem.mapFromServer(data.lessonItem);
		}

		if (pupil) {
			this.pupil = pupil;
		} else if (data.pupil) {
			this.pupil = usePupilsStore().findByIdOrMap(data.pupil);
		}

		if (data.observations) {
			this.observations = data.observations.map((observation: any) => {
				return Observation.createFromApiData(observation, this.pupil);
			});
		}

		if (data.feedback !== null) {
			this.feedback = data.feedback;
		}

		if (typeof(data.duration) !== 'undefined') {
			this.duration = Duration.fromMillis(data.duration * 1000);
		}

		if (typeof(data.breakDuration) !== 'undefined') {
			this.breakDuration = Duration.fromMillis(data.breakDuration * 1000);
		}

		return this;
	}

	removeObservation(observation: Observation) {
		if (!this.observations) {
			return;
		}

		this.observations = this.observations.filter((o: Observation) => o.id !== observation.id);
	}

	getDuration() {
		if (this.checkin) {
			if (this.checkout) {
				return Duration.fromMillis(this.checkout.getTime() - this.checkin.getTime());
			} else {
				return Duration.fromMillis((new Date).getTime() - this.checkin.getTime());
			}
		}
		return null;
	}
}
